import React, { Component } from "react";
import {  Switch, Redirect, Route } from "react-router-dom";

import Header from "components/FrontEnd/Header/Header";
import Footer from "components/FrontEnd/Footer/Footer";

import FrontEndRoutes from "routes/FrontEndRoutes.jsx";
import {  FrontEndAuthRoute } from 'helper/PrivateRouteFrontEnd';
// import Favicon from 'react-favicon';
// import favicon_front_end from "assets/img/favicon_front_end.png";

import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/fonts/sourceSansPro.css";
import "../../assets/css/owl.carousel.css";
import "../../assets/css/owl.theme.css";
import "../../assets/css/owl.transitions.css";
import "../../assets/css/reset.css";
import "../../assets/css/style.css";


class Frontend extends Component {
  componentDidMount(){
    document.title = "MUSIC ADJUDICATOR"
  }
  render() {
    // require('bootstrap/dist/css/bootstrap.min.css')
    // require("../../assets/fonts/sourceSansPro.css");
    // require("../../assets/css/owl.carousel.css");
    // require("../../assets/css/owl.theme.css");
    // require("../../assets/css/owl.transitions.css");
    // require("../../assets/css/reset.css");
    // require("../../assets/css/style.css");
    return (
      <div className="section-frontEnd">
        { /*<Favicon url={favicon_front_end} /> */}
        <Header {...this.props} />
        <div  className="" ref="mainPanel">
          <Switch>
            {
              FrontEndRoutes.map((prop, key) => {
                if (prop.redirect){
                  return <Redirect from={prop.path} to={prop.to} key={key} test="haha" />;
                }
                // console.log('tesddddd', prop.path)
                if (prop.path === '/Dashboard'){
                  return (
                    <FrontEndAuthRoute  path={prop.path}  component={prop.component} key={key}  />
                  );
                } else {
                  return (
                    <Route  path={prop.path}  component={prop.component} key={key}  />
                  );
                }
              })
            }
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}


export default Frontend;



// WEBPACK FOOTER //
// ./src/layouts/Frontend/Frontend.jsx